
const container = document.getElementById('ProductGridContainer');

function onItemVariantChange(target) {
  const formId = target.getAttribute('form');
  const quickAddForm = document.querySelector('#'+formId);
  const options = getSelectedOptions(formId);
  const selectedVariant = getSelectedVariant(formId, options);

  if (selectedVariant) {
    updateFormWithVariant(quickAddForm, selectedVariant);
    updatePriceAndButton(selectedVariant, formId, quickAddForm);
  }
}


// Get selected variant options
function getSelectedOptions(formId) {
  const fieldsets = Array.from(document.querySelectorAll(`.card__variant-radios-${formId}`));
  return fieldsets.map((fieldset) => 
    Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value
  );
}

// Get the matching variant from the variant data
function getSelectedVariant(formId, options) {
  const variantData = JSON.parse(document.querySelector(`#variantPriceJSON-${formId}`).textContent);
  return variantData.find((variant) => 
    !variant.options.some((option, index) => options[index] !== option)
  );
}

// Update the form with the selected variant ID
function updateFormWithVariant(quickAddForm, selectedVariant) {
  quickAddForm.querySelector('input[name="id"]').value = selectedVariant.id;
}

function onSubOptionSelectorChange(target) {
  const formId = target.getAttribute('form');
  const quickAddForm = document.querySelector(`#${formId}`);
  const selector = document.querySelector(`#productOptions-${formId}`);
  const hiddenInput = quickAddForm.querySelector('input[name="id"]');

  let selectedValue = selector.value;
  hiddenInput.value = selectedValue;

  // Handle one-time purchase
  if (isOneTimePurchase(selector)) {
    removeSubscriptionInput(quickAddForm);
    selectedValue = selectedValue+'onetime';
  }

  // Handle subscription purchase
  const selectedOption = getSelectedSubOption(formId, selectedValue);
  if (selectedOption) {
    updateSellingPlan(quickAddForm, selectedOption);
    updatePriceAndButton(selectedOption, formId, quickAddForm);
  }
}

function isOneTimePurchase(selector) {
  return selector.options[selector.selectedIndex].getAttribute('data-purchase-type') == 'one-time';
}

function removeSubscriptionInput(quickAddForm) {
  const subInput = quickAddForm.querySelector('input[name="selling_plan"]');
  if (subInput) subInput.remove();
}

function getSelectedSubOption(formId, selectedValue) {
  const subData = JSON.parse(document.querySelector(`#subscriptionJSON-${formId}`).textContent);
  return subData.find(variant => variant.id === selectedValue);
}

function updateSellingPlan(quickAddForm, selectedOption) {
  let subInput = quickAddForm.querySelector('input[name="selling_plan"]');
  if (!subInput) {
    subInput = document.createElement('input');
    subInput.type = 'hidden';
    subInput.name = 'selling_plan';
    quickAddForm.insertBefore(subInput, quickAddForm.querySelector('button[type=submit]'));
  }
  subInput.value = selectedOption.selling_plan_id;
}

function updatePriceAndButton(selectedVariant, formId, quickAddForm) {
  toggleQuickAddButton(selectedVariant.available, true, quickAddForm);
  itemUpdatePrice(selectedVariant, document.querySelector(`.price--${formId}`));
}

function toggleQuickAddButton(available, modifyClass = true, productForm) {
  if (!productForm) return;

  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = addButton.querySelector('span');
  if (!addButton) return;

  if (available) {
    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.addToCart;
  } else {
    addButton.setAttribute('disabled', 'disabled');
    addButtonText.textContent = window.variantStrings.soldOut;
  }
  if (!modifyClass) return;
}

function itemUpdatePrice(selectedVariant, priceWrapper) {
  const compareAtPrice = selectedVariant.compare_at_price;
  const compareAtPriceMoney = selectedVariant.compare_at_price_money;
  const priceMoney = selectedVariant.price_money;

  priceWrapper.querySelector('.price-item--regular').textContent = priceMoney;

  if(compareAtPrice != null && compareAtPrice > 0 && compareAtPriceMoney !== priceMoney) {
    priceWrapper.querySelector('.price__sale .price-item--regular').textContent = compareAtPriceMoney;
    priceWrapper.querySelector('.price-item--sale').textContent = priceMoney;
    priceWrapper.classList.add('price--on-sale');
  }
  else {
    priceWrapper.classList.remove('price--on-sale');
  }
}

container.addEventListener('change', evt => {
  const { target } = evt;
  if (target.matches('input[type=radio]')) {
    onItemVariantChange(target);
  }
  else if (target.matches('.quick-add__select')) {
    onSubOptionSelectorChange(target);
  }
});

/*
  Trigger 'change' events on all <select> elements to ensure the correct initial option or variant is selected 
  and prices are updated
*/
for (const select of document.querySelectorAll('.quick-add__select')) {
  select.dispatchEvent(new Event('change', { bubbles: true }));
}

const LOADING_DURATION = 1600;
container.addEventListener('click', (evt) => {
  const addToCartButton = evt.target
  if ( addToCartButton.classList.contains('quick-add__submit') && ! addToCartButton.disabled) {
    addToCartButton.classList.add('loading');

    const spinner = addToCartButton.querySelector('.loading-overlay__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }
    
    setTimeout(() => {
      addToCartButton.classList.remove('loading');
      if (spinner) {
        spinner.classList.add('hidden');
      }
    }, LOADING_DURATION);
  }
});


